import React, { useState } from 'react';
import PropTypes from 'prop-types';
import FormFieldOneInput from './fields/FormFieldOneInput';
import { getDefaultContactDisclaimer } from '../../utils';

const ContactDisclaimerForm = ({ errorMessage, setFieldValue }) => {
	const [key, setKey] = useState(0);

	const forceRefresh = () => {
		setKey(key + 1);
	};

	return (
		<FormFieldOneInput
			errorMessage={errorMessage}
			control="editor"
			fieldName="contact_disclaimer"
			placeholder="Contact disclaimer"
			key={key}
			defaultFieldValue={getDefaultContactDisclaimer({})}
			setFieldValue={setFieldValue}
			forceRefresh={forceRefresh}
		/>
	);
};

ContactDisclaimerForm.propTypes = {
	errorMessage: PropTypes.string,
	setFieldValue: PropTypes.func,
};

export default ContactDisclaimerForm;
